import { appHttpClient } from "../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../installations/http/inFlight";

export const login = (data) => {
  return appHttpClient.post(`/Account/Login`, data);
};

export const registerBusiness = (data) => {
  return appHttpClient.post(`/Account/Register/Business`, data);
};

export const getUserInfo = (data) => {
  // 0015: dedupe concurrent identical fetches (StrictMode double-mount) into one network request.
  return dedupeRequest(`userInfo:${data}`, () =>
    appHttpClient.get(`/Account/UserInfo`, {
      params: { token: data },
    })
  );
};

export const getUsersByBusinessCustomer = () => {
  // 0016: dedupe StrictMode double-invoke into one network request (single endpoint, no params).
  return dedupeRequest("usersByBusinessCustomer", () =>
    appHttpClient.get(`/Account/UsersByBusinessCustomer`)
  );
};

export const deleteAccount = (email) => {
  return appHttpClient.post(`/Account/DeleteUser/${email}`);
};

// 0007: suspend/activate a business account by Id (admin-only endpoint).
export const setBusinessAccountActive = (id, isActive) => {
  return appHttpClient.put(`/Account/${id}/Active`, { isActive });
};

// 0007: edit a business account's person details (first/last/phone) by Id (admin-only). Does NOT
// change email/password/linked customer and never writes to Rivhit.
export const updateBusinessAccount = (id, data) => {
  return appHttpClient.put(`/Account/${id}`, data);
};

const accountService = {
  login,
  registerBusiness,
  getUserInfo,
  getUsersByBusinessCustomer,
  deleteAccount,
  setBusinessAccountActive,
  updateBusinessAccount,
};

export default accountService;
